import { render, staticRenderFns } from "./ChampionBattleGame.vue?vue&type=template&id=140e34a2&scoped=true&"
import script from "./ChampionBattleGame.vue?vue&type=script&lang=js&"
export * from "./ChampionBattleGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e34a2",
  null
  
)

export default component.exports